import avatar from '../assets/your_avatar.jpg';
import slide1 from '../assets/Offline_ABTesting/Slide1.jpeg';
import slide2 from '../assets/Offline_ABTesting/Slide2.jpeg';
import slide3 from '../assets/Offline_ABTesting/Slide3.jpeg';
import slide4 from '../assets/Offline_ABTesting/Slide4.jpeg';
import slide5 from '../assets/Offline_ABTesting/Slide5.jpeg';
import slide6 from '../assets/Offline_ABTesting/Slide6.jpeg';
import slide7 from '../assets/Offline_ABTesting/Slide7.jpeg';
import slide8 from '../assets/Offline_ABTesting/Slide8.jpeg';
import slide9 from '../assets/Offline_ABTesting/Slide9.jpeg';
import slide10 from '../assets/Offline_ABTesting/Slide10.jpeg';
import slide11 from '../assets/Offline_ABTesting/Slide11.jpeg';
import slide12 from '../assets/Offline_ABTesting/Slide12.jpeg';
import slide13 from '../assets/Offline_ABTesting/Slide13.jpeg';
import slide14 from '../assets/Offline_ABTesting/Slide14.jpeg';
import slide15 from '../assets/Offline_ABTesting/Slide15.jpeg';
import slide16 from '../assets/Offline_ABTesting/Slide16.jpeg';
import slide17 from '../assets/Offline_ABTesting/Slide17.jpeg';
import slide18 from '../assets/Offline_ABTesting/Slide18.jpeg';
import slide19 from '../assets/Offline_ABTesting/Slide19.jpeg';
import slide20 from '../assets/Offline_ABTesting/Slide20.jpeg';
import slide21 from '../assets/Offline_ABTesting/Slide21.jpeg';
import slide22 from '../assets/Offline_ABTesting/Slide22.jpeg';
import slide23 from '../assets/Offline_ABTesting/Slide23.jpeg';
import slide24 from '../assets/Offline_ABTesting/Slide24.jpeg';
import slide25 from '../assets/Offline_ABTesting/Slide25.jpeg';
import slide26 from '../assets/Offline_ABTesting/Slide26.jpeg';
import slide27 from '../assets/Offline_ABTesting/Slide27.jpeg';

export default function OfflineABTesting() {
    return (
      <main id="report" className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
        <article className="max-w-4xl mx-auto">
  
          {/* Hero Header */}
          <header className="mb-12 text-center">
            <h1 className="text-5xl lg:text-6xl font-extrabold text-gray-900">
              Offline A/B Testing for Recommender Systems
            </h1>
            <div className="mt-6 flex items-center justify-center text-gray-500 text-sm space-x-3">
              <img src={avatar} alt="Author avatar" className="w-8 h-8 rounded-full" />
              <span><strong>Jooho Kim</strong></span>
              <span>·</span>
              <span>Arizona State University</span>
              <span>·</span>
              <span>Computer Science</span>
              <span>·</span>
              <time dateTime="2025-12-08">Dec 8, 2025</time>
            </div>
          </header>

          {/* Slides */}
          <div className="space-y-8">
            <img src={slide1} alt="Slide 1" className="w-full rounded-lg shadow-lg border" />
            <img src={slide2} alt="Slide 2" className="w-full rounded-lg shadow-lg border" />
            <img src={slide3} alt="Slide 3" className="w-full rounded-lg shadow-lg border" />
            <img src={slide4} alt="Slide 4" className="w-full rounded-lg shadow-lg border" />
            <img src={slide5} alt="Slide 5" className="w-full rounded-lg shadow-lg border" />
            <img src={slide6} alt="Slide 6" className="w-full rounded-lg shadow-lg border" />
            <img src={slide7} alt="Slide 7" className="w-full rounded-lg shadow-lg border" />
            <img src={slide8} alt="Slide 8" className="w-full rounded-lg shadow-lg border" />
            <img src={slide9} alt="Slide 9" className="w-full rounded-lg shadow-lg border" />
            <img src={slide10} alt="Slide 10" className="w-full rounded-lg shadow-lg border" />
            <img src={slide11} alt="Slide 11" className="w-full rounded-lg shadow-lg border" />
            <img src={slide12} alt="Slide 12" className="w-full rounded-lg shadow-lg border" />
            <img src={slide13} alt="Slide 13" className="w-full rounded-lg shadow-lg border" />
            <img src={slide14} alt="Slide 14" className="w-full rounded-lg shadow-lg border" />
            <img src={slide15} alt="Slide 15" className="w-full rounded-lg shadow-lg border" />
            <img src={slide16} alt="Slide 16" className="w-full rounded-lg shadow-lg border" />
            <img src={slide17} alt="Slide 17" className="w-full rounded-lg shadow-lg border" />
            <img src={slide18} alt="Slide 18" className="w-full rounded-lg shadow-lg border" />
            <img src={slide19} alt="Slide 19" className="w-full rounded-lg shadow-lg border" />
            <img src={slide20} alt="Slide 20" className="w-full rounded-lg shadow-lg border" />
            <img src={slide21} alt="Slide 21" className="w-full rounded-lg shadow-lg border" />
            <img src={slide22} alt="Slide 22" className="w-full rounded-lg shadow-lg border" />
            <img src={slide23} alt="Slide 23" className="w-full rounded-lg shadow-lg border" />
            <img src={slide24} alt="Slide 24" className="w-full rounded-lg shadow-lg border" />
            <img src={slide25} alt="Slide 25" className="w-full rounded-lg shadow-lg border" />
            <img src={slide26} alt="Slide 26" className="w-full rounded-lg shadow-lg border" />
            <img src={slide27} alt="Slide 27" className="w-full rounded-lg shadow-lg border" />
          </div>

          
        </article>
      </main>
    );
}